import { render, staticRenderFns } from "./provider-articles.vue?vue&type=template&id=5a7b9d2e&scoped=true&lang=pug&"
import script from "./provider-articles.vue?vue&type=script&lang=js&"
export * from "./provider-articles.vue?vue&type=script&lang=js&"
import style0 from "./provider-articles.vue?vue&type=style&index=0&id=5a7b9d2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7b9d2e",
  null
  
)

/* custom blocks */
import block0 from "./provider-articles.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SiteBlogPreview: require('/home/ubuntu/nuxt/bonkers/releases/20230331143208/components/site/blog/preview.vue').default})
